// extracted by mini-css-extract-plugin
module.exports = {"Details":"Details__Details--tEVqn","List":"Details__List--1Fgni"};